/* eslint-disable import/no-unresolved */

import { provide } from 'vue';

import { createVueApp } from '@vuejs/entry';

import SharedOffcanvasApp from '@vuejs/apps/SharedOffcanvasApp.vue';
import SharedModalApp from '@vuejs/apps/SharedModalApp.vue';
import SharedPopupApp from '@vuejs/apps/SharedPopupApp.vue';
// import CategoryFiltersApp from '@vuejs/apps/CategoryFiltersApp.vue';

import { createPinia } from 'pinia';
import { register } from 'swiper/element/bundle';

import lozad from 'lozad';

register();
const sharedPinia = createPinia();

/**
 * Aplikacje ładowane globalnie
 */
document.addEventListener('DOMContentLoaded', async () => {
    const sharedOffcanvasApp = createVueApp(SharedOffcanvasApp);
    const sharedModalApp = createVueApp(SharedModalApp);
    const sharedPopupApp = createVueApp(SharedPopupApp);

    sharedOffcanvasApp.use(sharedPinia);
    sharedModalApp.use(sharedPinia);
    sharedPopupApp.use(sharedPinia);

    sharedOffcanvasApp.mount('#shared-offcanvas-app');
    sharedModalApp.mount('#shared-modal-app');
    sharedPopupApp.mount('#shared-popup-app');
});

/**
 * Aplikacje ładowanie na odpowiednich podstronach
 */
window.addEventListener('page-loaded.category', async () => {
    const CategoryFiltersApp = await import(
        /** webpackChunkName: 'CategoryFiltersApp' */ '@vuejs/apps/CategoryFiltersApp.vue'
    );
    const categoryFiltersApp = createVueApp(CategoryFiltersApp.default);

    categoryFiltersApp.use(sharedPinia);

    categoryFiltersApp.mount('#category-filters-app');
});

window.addEventListener('page-loaded.checkout', async () => {
    const CheckoutApp = await import(
        /** webpackChunkName: 'CheckoutApp' */ '@vuejs/apps/CheckoutApp.vue'
    );
    const { checkoutRouter } = await import(
        /** webpackChunkName: 'checkoutRouter' */ '@vuejs/router/checkout'
    );
    const { useAuthStore } = await import(/** webpackChunkName: 'authStore' */ '@vuejs/store/auth');

    const checkoutApp = createVueApp(CheckoutApp.default);
    const authStore = useAuthStore();

    checkoutApp.use(sharedPinia);
    checkoutApp.use(checkoutRouter);

    checkoutApp.mount('#checkout-app');

    authStore.me();
});

window.addEventListener('page-loaded.checkout-success', async () => {
    const CheckoutSuccessApp = await import(
        /** webpackChunkName: 'CheckoutSuccessApp' */ '@vuejs/apps/CheckoutSuccessApp.vue'
    );

    const checkoutSuccessApp = createVueApp(CheckoutSuccessApp.default);

    checkoutSuccessApp.mount('#checkout-success-app');
});

/**
 * Aplikacje ładowane on-demand
 */
window.addEventListener('DOMContentLoaded', async () => {
    const TopbarApp = await import(/* webpackChunkName: "TopbarApp" */ '@vuejs/apps/TopbarApp.vue');

    const topbarElements = document.querySelectorAll('.js-vue-topbar');

    topbarElements.forEach((el) => {
        const topbarApp = createVueApp(TopbarApp.default);

        topbarApp.use(sharedPinia);
        topbarApp.provide('topbar', JSON.parse(el.dataset.topbar));

        topbarApp.mount(el);
    });

    if (document.querySelector('#search-app')) {
        const SearchApp = await import(
            /* webpackChunkName: "SearchApp" */ '@vuejs/apps/SearchApp.vue'
        );

        const searchApp = createVueApp(SearchApp.default);

        searchApp.use(sharedPinia);

        searchApp.mount('#search-app');
    }

    // window.PROMOTION.top_bars.forEach((topbar) => {
    //     const topbarApp = createVueApp(TopbarApp.default);
    //     const targetElement = document.querySelector('#js-mount-topbars-after-this-element');
    //     const mountElement = document.createElement('div');
    //     targetElement.parentNode.insertBefore(mountElement, targetElement.nextSibling);

    //     topbarApp.use(sharedPinia);
    //     topbarApp.provide('topbar', topbar);

    //     topbarApp.mount(mountElement);
    // });

    // if (document.querySelector('#topbar-app')) {
    //     const TopbarApp = await import(
    //         /* webpackChunkName: "TopbarApp" */ '@vuejs/apps/TopbarApp.vue'
    //     );

    //     const topbarApp = createVueApp(TopbarApp.default);

    //     topbarApp.use(sharedPinia);

    //     topbarApp.mount('#topbar-app');
    // }

    if (document.querySelector('#header-app')) {
        const HeaderApp = await import(
            /* webpackChunkName: "NewsletterApp" */ '@vuejs/apps/HeaderApp.vue'
        );

        const headerApp = createVueApp(HeaderApp.default);

        headerApp.use(sharedPinia);

        headerApp.mount('#header-app');
    }
    if (document.querySelector('#newsletter-app')) {
        const NewsletterApp = await import(
            /* webpackChunkName: "NewsletterApp" */ '@vuejs/apps/NewsletterApp.vue'
        );

        const newsletterApp = createVueApp(NewsletterApp.default);

        newsletterApp.use(sharedPinia);

        newsletterApp.mount('#newsletter-app');
    }

    if (document.querySelector('#exit-popup-lead-app')) {
        const ExitPopupLeadApp = await import(
            /* webpackChunkName: "ExitPopupLeadApp" */ '@vuejs/apps/ExitPopupLeadApp.vue'
        );

        const exitPopupLeadApp = createVueApp(ExitPopupLeadApp.default);

        exitPopupLeadApp.use(sharedPinia);

        exitPopupLeadApp.mount('#exit-popup-lead-app');
    }

    if (document.querySelector('#ebook-page-app')) {
        const EbookPageApp = await import(
            /* webpackChunkName: "EbookPageApp" */ '@vuejs/apps/EbookPageApp.vue'
        );

        const ebookPageApp = createVueApp(EbookPageApp.default);

        ebookPageApp.use(sharedPinia);

        ebookPageApp.mount('#ebook-page-app');
    }

    if (document.querySelector('#ebook-app')) {
        const EbookApp = await import(
            /* webpackChunkName: "EbookApp" */ '@vuejs/apps/EbookApp.vue'
        );

        const ebookApp = createVueApp(EbookApp.default);

        ebookApp.use(sharedPinia);

        ebookApp.mount('#ebook-app');
    }

    // const productGalleryDesktopAppElement = document.querySelector('#product-gallery-desktop-app');

    // if (productGalleryDesktopAppElement) {
    //     const ProductGalleryDesktopApp = await import(
    //         /* webpackChunkName: "ProductGalleryDesktopApp" */ '@vuejs/apps/product/ProductGalleryDesktopApp.vue'
    //     );

    //     const productGalleryDesktopApp = createVueApp(ProductGalleryDesktopApp.default, {
    //         globalState: {
    //             productDTO: JSON.parse(productGalleryDesktopAppElement.dataset.productDto),
    //             stoneInfo: JSON.parse(productGalleryDesktopAppElement.dataset.stoneInfo),
    //         },
    //     });

    //     productGalleryDesktopApp.use(sharedPinia);

    //     productGalleryDesktopApp.mount(productGalleryDesktopAppElement);
    // }

    if (document.querySelector('#ring-sets-app')) {
        const RingSetsApp = await import(
            /* webpackChunkName: "EbookApp" */ '@vuejs/apps/RingSetsApp.vue'
        );

        const ringSetsApp = createVueApp(RingSetsApp.default);

        ringSetsApp.use(sharedPinia);

        ringSetsApp.mount('#ring-sets-app');
    }

    if (document.querySelector('#finished-product-app')) {
        const FinishedProductApp = await import(
            /* webpackChunkName: "ReadyProductsApp" */ '@vuejs/apps/product/FinishedProductApp.vue'
        );

        const finishedProductApp = createVueApp(FinishedProductApp.default);

        finishedProductApp.use(sharedPinia);

        finishedProductApp.mount('#finished-product-app');
    }

    if (document.querySelector('#finished-products-app')) {
        const FinishedProductsApp = await import(
            /* webpackChunkName: "ReadyProductsApp" */ '@vuejs/apps/product/FinishedProductsApp.vue'
        );

        const sylgemsApp = createVueApp(FinishedProductsApp.default);

        sylgemsApp.use(sharedPinia);

        sylgemsApp.mount('#finished-products-app');
    }

    if (document.querySelector('#individual-offer-app')) {
        const IndividualOfferApp = await import(
            /* webpackChunkName: "IndividualOfferApp" */ '@vuejs/apps/IndividualOfferApp.vue'
        );

        const individualOfferApp = createVueApp(IndividualOfferApp.default);

        individualOfferApp.use(sharedPinia);

        individualOfferApp.mount('#individual-offer-app');
    }

    if (document.querySelector('#diamond-purchase-app')) {
        const DiamondPurchaseApp = await import(
            /* webpackChunkName: "ReadyProductsApp" */ '@vuejs/apps/product/DiamondPurchaseApp.vue'
        );

        const sylgemsApp = createVueApp(DiamondPurchaseApp.default);

        sylgemsApp.use(sharedPinia);

        sylgemsApp.mount('#diamond-purchase-app');
    }

    if (document.querySelector('#delivery-app')) {
        const DeliveryApp = await import(
            /* webpackChunkName: "ReadyProductsApp" */ '@vuejs/apps/product/DeliveryApp.vue'
        );

        const deliveryApp = createVueApp(DeliveryApp.default);

        deliveryApp.use(sharedPinia);

        deliveryApp.mount('#delivery-app');
    }

    const buyBoxAppElement = document.querySelector('#buybox-app');

    if (buyBoxAppElement) {
        const BuyboxApp = await import(
            /* webpackChunkName: "BuyboxApp" */ '@vuejs/apps/product/BuyboxApp.vue'
        );

        const buyboxApp = createVueApp(BuyboxApp.default, {
            globalState: {
                productDTO: JSON.parse(buyBoxAppElement.dataset.productDto),
            },
        });

        buyboxApp.use(sharedPinia);

        buyboxApp.mount(buyBoxAppElement);
    }

    if (document.querySelector('#promotion-landing-app')) {
        const PromotionLandingApp = await import(
            /* webpackChunkName: "EbookApp" */ '@vuejs/apps/PromotionLandingApp.vue'
        );

        const promotionLandingApp = createVueApp(PromotionLandingApp.default);

        promotionLandingApp.use(sharedPinia);

        promotionLandingApp.mount('#promotion-landing-app');
    }

    const miniCartAppElements = document.querySelectorAll('#mini-cart-app');

    if (miniCartAppElements.length) {
        const MiniCartApp = await import(
            /** webpackChunkName: "MiniCartApp" */ '@vuejs/apps/MiniCartApp.vue'
        );

        miniCartAppElements.forEach((el) => {
            const miniCartApp = createVueApp(MiniCartApp.default);

            miniCartApp.use(sharedPinia);

            miniCartApp.mount(el);
        });
    }

    const myAccountAppElements = document.querySelectorAll('.my-account-app');

    if (myAccountAppElements.length) {
        const MyAccountApp = await import(
            /** webpackChunkName: "MyAccountApp" */ '@vuejs/apps/MyAccountApp.vue'
        );
        myAccountAppElements.forEach((el) => {
            const myAccountApp = createVueApp(MyAccountApp.default);
            myAccountApp.use(sharedPinia);
            myAccountApp.mount(el);
        });
    }

    if (document.querySelector('#login-form-app')) {
        const LoginFormApp = await import(
            /* webpackChunkName: "LoginFormApp" */ '@vuejs/apps/LoginFormApp.vue'
        );

        const loginFormApp = createVueApp(LoginFormApp.default);

        loginFormApp.use(sharedPinia);

        loginFormApp.mount('#login-form-app');
    }
    if (document.querySelector('#register-form-app')) {
        const RegisterFormApp = await import(
            /* webpackChunkName: "RegisterFormApp" */ '@vuejs/apps/RegisterFormApp.vue'
        );

        const registerFormApp = createVueApp(RegisterFormApp.default);

        registerFormApp.use(sharedPinia);

        registerFormApp.mount('#register-form-app');
    }
    if (document.querySelector('#receive-gift-lead-app')) {
        const ReceiveGiftLeadApp = await import(
            /* webpackChunkName: "ReceiveGiftLeadApp" */ '@vuejs/apps/ReceiveGiftLeadApp.vue'
        );

        const receiveGiftLeadApp = createVueApp(ReceiveGiftLeadApp.default);

        receiveGiftLeadApp.use(sharedPinia);

        receiveGiftLeadApp.mount('#receive-gift-lead-app');
    }

    if (document.querySelector('#collection-listing-header-app')) {
        const CollectionListingHeaderApp = await import(
            /* webpackChunkName: "ReadyProductsApp" */ '@vuejs/apps/CollectionListingHeaderApp.vue'
        );

        const collectionListingHeaderApp = createVueApp(CollectionListingHeaderApp.default);

        collectionListingHeaderApp.use(sharedPinia);

        collectionListingHeaderApp.mount('#collection-listing-header-app');
    }

    if (document.querySelector('#products-list-count-app')) {
        const ProductsListCountApp = await import(
            /* webpackChunkName: "ProductsListCountApp" */ '@vuejs/apps/ProductsListCountApp.vue'
        );

        const productsListCountApp = createVueApp(ProductsListCountApp.default);

        productsListCountApp.use(sharedPinia);

        productsListCountApp.mount('#products-list-count-app');
    }

    if (document.querySelector('.items-to-item-recommendations-app')) {
        const ItemsToItemRecommendationsApp = await import(
            /* webpackChunkName: "ProductsListCountApp" */ '@vuejs/apps/recombee/ItemsToItemRecommendationsApp.vue'
        );

        const itemsToItemRecommendationsAppElements = document.querySelectorAll(
            '.items-to-item-recommendations-app'
        );

        itemsToItemRecommendationsAppElements.forEach((el) => {
            const itemsToItemRecommendationsApp = createVueApp(
                ItemsToItemRecommendationsApp.default
            );

            itemsToItemRecommendationsApp.provide('productId', el.dataset.productId);

            const recombeeConfiguration = JSON.parse(el.dataset.recombeeConfiguration || '{}');

            if (recombeeConfiguration) {
                itemsToItemRecommendationsApp.provide(
                    'recombeeConfiguration',
                    recombeeConfiguration
                );
            }

            itemsToItemRecommendationsApp.use(sharedPinia);

            itemsToItemRecommendationsApp.mount(el);
        });
    }

    if (document.querySelector('.items-to-user-recommendations-app')) {
        const ItemsToUserRecommendationsApp = await import(
            /* webpackChunkName: "ProductsListCountApp" */ '@vuejs/apps/recombee/ItemsToUserRecommendationsApp.vue'
        );

        const itemsToUserRecommendationsAppElements = document.querySelectorAll(
            '.items-to-user-recommendations-app'
        );

        itemsToUserRecommendationsAppElements.forEach((el) => {
            const itemsToUserRecommendationsApp = createVueApp(
                ItemsToUserRecommendationsApp.default
            );

            const recombeeConfiguration = JSON.parse(el.dataset.recombeeConfiguration || '{}');

            if (recombeeConfiguration) {
                itemsToUserRecommendationsApp.provide(
                    'recombeeConfiguration',
                    recombeeConfiguration
                );
            }

            itemsToUserRecommendationsApp.use(sharedPinia);

            itemsToUserRecommendationsApp.mount(el);
        });
    }
});

/**
 * Komunikacja między SSR a apką vue
 */
['DOMContentLoaded', 'livewire.component.rendered'].forEach((ev) => {
    window.addEventListener(ev, () => {
        const elements = [...document.querySelectorAll('.js-vue-offcanvas-show')].filter(
            (el) => !el.dataset.vueOffcanvasShowListenerInitialized
        );

        elements.forEach((el) => {
            el.dataset.vueOffcanvasShowListenerInitialized = true;

            el.addEventListener('click', (e) => {
                e.preventDefault();

                const { componentName, payload } = el.dataset;

                window.dispatchEvent(
                    new CustomEvent('vue.offcanvas.show', {
                        detail: { componentName, payload: JSON.parse(payload || '{}') },
                    })
                );
            });
        });

        // promotion modules

        const promotionModulesElements = [
            ...document.querySelectorAll('.js-vue-promotion-show'),
        ].filter((el) => !el.dataset.vuePromotionShowListenerInitialized);

        promotionModulesElements.forEach((el) => {
            el.dataset.vuePromotionShowListenerInitialized = true;

            el.addEventListener('click', (e) => {
                e.preventDefault();

                const { componentName, payload, actionUrl } = el.dataset;

                if (actionUrl) {
                    window.location.href = actionUrl;

                    return;
                }

                const templateCode = window.PROMOTION_MODAL?.promotion_template?.code;

                if (!templateCode) {
                    return;
                }

                if (templateCode === 'basic_modal') {
                    window.dispatchEvent(
                        new CustomEvent('vue.modal.show', {
                            detail: {
                                componentName: componentName.replace('Offcanvas', 'Modal'),
                                payload: JSON.parse(payload || '{}'),
                            },
                        })
                    );
                } else {
                    window.dispatchEvent(
                        new CustomEvent('vue.offcanvas.show', {
                            detail: { componentName, payload: JSON.parse(payload || '{}') },
                        })
                    );
                }
            });
        });
    });
});

// lozad

const appsToLazyLoad = [
    {
        selector: '#product-gallery-desktop-app',
        getRootComponent: () =>
            import(
                /* webpackChunkName: "ProductGalleryDesktopApp" */ '@vuejs/apps/product/ProductGalleryDesktopApp.vue'
            ),
        getGlobalState: (rootElement) => ({
            productDTO: window.PRODUCT_DTO,
            stoneInfo: JSON.parse(rootElement.dataset.stoneInfo),
        }),
    },
    {
        selector: '#product-gallery-mobile-app',
        getRootComponent: () =>
            import(
                /* webpackChunkName: "ProductGalleryMobileApp" */ '@vuejs/apps/product/ProductGalleryMobileApp.vue'
            ),
        getGlobalState: (rootElement) => ({
            productDTO: window.PRODUCT_DTO,
            stoneInfo: JSON.parse(rootElement.dataset.stoneInfo),
        }),
    },
    {
        selector: '#product-reviews-app',
        getRootComponent: () =>
            import(
                /* webpackChunkName: "ProductReviewsApp" */ '@vuejs/apps/product/ProductReviewsApp.vue'
            ),
        getGlobalState: () => ({
            productDTO: window.PRODUCT_DTO,
        }),
    },
    {
        selector: '#product-fast-actions',
        getRootComponent: () =>
            import(
                /* webpackChunkName: "ProductFastActionsApp" */ '@vuejs/apps/product/ProductFastActionsApp.vue'
            ),
        getGlobalState: () => ({
            productDTO: window.PRODUCT_DTO,
        }),
    },
];
appsToLazyLoad.forEach((appData) => {
    const observer = lozad(appData.selector, {
        loaded: async (el) => {
            const component = await appData.getRootComponent();

            const app = createVueApp(component.default, {
                globalState: appData.getGlobalState(el),
            });

            app.use(sharedPinia);

            app.mount(el);
        },
    });

    document.addEventListener('DOMContentLoaded', () => {
        observer.observe();
    });
});

/**
 * LISTING RECOMMENDATIONS APP
 */

// let hasLoadedRecommendations = false;

window.addEventListener('products-list-loaded', async (e) => {
    // if (document.querySelector('#last-seen-product-app')) {
    //     const LastSeenProductApp = await import(
    //         /* webpackChunkName: "ProductsListCountApp" */ '@vuejs/apps/LastSeenProductApp.vue'
    //     );

    //     const lastSeenProductApp = createVueApp(LastSeenProductApp.default);

    //     lastSeenProductApp.use(sharedPinia);

    //     lastSeenProductApp.mount('#last-seen-product-app');
    // }

    // const listingRecommendationsAppElements = document.querySelectorAll(
    //     '.listing-recommendations-app'
    // );

    // if (listingRecommendationsAppElements.length && !hasLoadedRecommendations) {
    //     const ListingRecommendationsApp = await import(
    //         /* webpackChunkName: "ProductsListCountApp" */ '@vuejs/apps/recombee/ListingRecommendationsApp.vue'
    //     );

    //     listingRecommendationsAppElements.forEach((el) => {
    //         const listingRecommendationsApp = createVueApp(ListingRecommendationsApp.default);

    //         const recombeeConfiguration = JSON.parse(el.dataset.recombeeConfiguration || '{}');

    //         if (recombeeConfiguration) {
    //             listingRecommendationsApp.provide('recombeeConfiguration', recombeeConfiguration);
    //         }

    //         listingRecommendationsApp.use(sharedPinia);

    //         listingRecommendationsApp.mount(el);
    //     });
    // }

    // if (hasLoadedRecommendations) {
    //     // window.dispatchEvent(new CustomEvent('products-list-recommendations-loaded'));
    //     listingRecommendationsAppElements.forEach((el) => {
    //         el.remove();
    //     });
    // }

    if (document.querySelector('.products-presentation-listing-app')) {
        const ProductsPresentationListingApp = await import(
            /* webpackChunkName: "ProductsListCountApp" */ '@vuejs/apps/ProductsPresentationListingApp.vue'
        );

        const productsPresentationListingAppElements = document.querySelectorAll(
            '.products-presentation-listing-app'
        );

        productsPresentationListingAppElements.forEach((el) => {
            const productsPresentationListingApp = createVueApp(
                ProductsPresentationListingApp.default
            );

            const configuration = JSON.parse(el.dataset.configuration || '{}');

            if (configuration) {
                productsPresentationListingApp.provide('configuration', configuration);
            }

            productsPresentationListingApp.use(sharedPinia);

            productsPresentationListingApp.mount(el);
        });
    }

    // hasLoadedRecommendations = true;
});
